import React, { useEffect, createElement } from 'react';
import { OfferBar } from './components/OfferBar';
import { ProgressBar } from './components/ProgressBar';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { GainPointsSection } from './components/GainPointsSection';
import { TopicsSection } from './components/TopicsSection';
import { PurchaseSection } from './components/PurchaseSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { GeoPricingProvider } from './hooks/GeoPricingContext';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1672032480458980');
    window.fbq('track', 'PageView');
  }, []);
  return <GeoPricingProvider data-id="element-0">
      <div className="font-poppins text-[15px] leading-relaxed text-dark-gray bg-cream overflow-x-hidden min-h-screen pt-10" data-id="element-1">
        <OfferBar data-id="element-2" />
        <ProgressBar data-id="element-3" />
        <HeroSection data-id="element-4" />
        <PainPointsSection data-id="element-5" />
        <GainPointsSection data-id="element-6" />
        <TopicsSection data-id="element-7" />
        <PurchaseSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FaqSection data-id="element-12" />
        <FinalOfferSection data-id="element-13" />
        <Footer data-id="element-14" />
      </div>
    </GeoPricingProvider>;
}